import React, { useEffect, useRef, useState } from 'react';

import { Divider, Stack, Typography } from '@mui/material';
import { IAlertProps } from '../../interface/IAlertProps';
import {
  getDefaultAlertProps,
  getOrCreateUserId,
  HandleAutoShopView,
} from '../../utils/utils';
import { MyAlert } from '../UI/MyAlert';
import Skelet from '../../image/webp_Skeleton.webp';
import Logo from '../../image/webp_Logo2.webp';
import { MyButton } from '../UI/MyButton';
import { LendingDivItemText } from './LendingDivtemText';
import { LendingDivtemTextWithImage } from './LendingDivtemTextWithImage';
import Anat from '../../image/Anatomy.svg';
import Hist from '../../image/Gistology.svg';
import Bioc from '../../image/Biochemistry.svg';
import Phys from '../../image/Physiology.svg';
import Fullbody from '../../image/Fullbody.svg';
import Latin from '../../image/Latin.svg';
import Blog from '../../image/Blog.svg';
import Listen from '../../image/Listen.svg';
import NameSkeleton from '../../image/Name.svg';
import { ReactComponent as Icon1 } from '../../image/Icon1.svg';
import { ReactComponent as Icon2 } from '../../image/Icon2.svg';
import { ReactComponent as Icon3 } from '../../image/Icon3.svg';
import { ReactComponent as Icon4 } from '../../image/Icon4.svg';
import { ReactComponent as ProfileSvg } from '../../image/Profile.svg';
import { ReactComponent as IdeaSvg } from '../../image/idea.svg';
import { ReactComponent as StarSvg } from '../../image/Star.svg';
import { ReactComponent as PremiumSvg } from '../../image/Premium.svg';
import AppInstall from '../../image/AppInstall.svg';
import ApplShop from '../../image/ApplShop.png';
import AndroidShop from '../../image/AndroidShop.png';
import HuaweiShop from '../../image/HuaweiShop.png';
import SkeletonLend1 from '../../image/webp_SkeletonLend.webp';
import SkeletonLend2 from '../../image/webp_SkeletonLend2.webp';
import SkeletonLend3 from '../../image/webp_SkeletonLend3.webp';
import SkeletonLend4 from '../../image/webp_SkeletonLend4.webp';
import SkeletonLend5 from '../../image/webp_SkeletonLend5.webp';
import SkeletonLend6 from '../../image/webp_SkeletonLend6.webp';
import SkeletonLend7 from '../../image/webp_SkeletonLend7.webp';
import SkeletonLend8 from '../../image/webp_SkeletonLend8.webp';
import DesctopImage from '../../image/webp_DesctopImage.webp';
import Image1 from '../../image/webp_iPhone13_1.webp';
import Image2 from '../../image/webp_iPhone13_2.webp';
import Image3 from '../../image/webp_iPhone13_3.webp';
import Image4 from '../../image/webp_Image4_1.webp';
import Image5 from '../../image/webp_Image5.webp';
import Image6 from '../../image/webp_Image6.webp';
import Image7 from '../../image/webp_Image7.webp';
import Image8 from '../../image/webp_Image8_1.webp';
import { LendingDivtemTextWithImage2 } from './LendingDivtemTextWithImage2';
import { LendingDivtemTextFooter } from './LendingDivtemTextFooter';
import { LendingDivItemTextOtziv } from './LendingDivtemTextOtziv';
import { PurchaseDiv } from '../purchase/PurchaseDiv';
import {
  API_STATUS_PROBLEM,
  DESCTOP_CHANGE,
  DESCTOP_TWO_BUTTON_CHANGE,
  DESCTOP_TWO_CHANGE,
  WINDOW_H,
  WINDOW_V,
} from '../../constant/constants';
import { IApiResult } from '../../interface/IApiResult';
import { apiCheckDevice } from '../../service/apiCheckDevice';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';

interface MarkerElement extends HTMLDivElement {
  dataset: {
    id: string;
  };
}

export const LendingDiv = () => {
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [userId, setUserId] = useState('');
  const [autoDevice, setAutoDevice] = useState(0);

  const [constHeight, setConstHeight] = useState(window.innerWidth);

  const [currentPosition, setCurrentPosition] = useState<number>(0);
  const [lastScrollY, setLastScrollY] = useState(window.scrollY);
  const [windowState, setWindowState] = useState(
    window.innerWidth > DESCTOP_CHANGE ? WINDOW_H : WINDOW_V
  );
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const onChange = () => {
    const qq = '';
  };
  const markersRef = useRef<MarkerElement[]>([]);

  const checkDevice = async () => {
    const apiResult: IApiResult = await apiCheckDevice();
    if (apiResult.isSuccess) {
      setAutoDevice(apiResult.data.device);
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const getSizePictureFona = () => {
    let widtn = window.innerWidth;
    let heghh = constHeight;
    if (windowState === WINDOW_V) {
      if (widtn > 746) {
        widtn = 746;
      }
      if (heghh > 2100) {
        heghh = 2100;
      }
      widtn = (heghh * 746) / 2100;
      return `${widtn}px ${heghh}px`;
    }
    if (widtn > 1234) {
      widtn = 1234;
    }
    if (heghh > 1920) {
      heghh = 1920;
    }
    widtn = (heghh * 1234) / 1920;
    return `${widtn}px ${heghh}px`;
  };

  // Добавляем элементы в массив ref с проверкой типа
  const addToRefs = (el: MarkerElement | null) => {
    if (el && !markersRef.current.includes(el)) {
      markersRef.current.push(el);
    }
  };

  const scrollToMarker = (id: number) => {
    const offset = 0;

    const marker = markersRef.current.find(
      (m) => m.dataset.id === `item_${id}`
    );
    if (!marker) return;

    const markerRect = marker.getBoundingClientRect();
    const absoluteMarkerTop = markerRect.top + window.pageYOffset;

    window.scrollTo({
      top: absoluteMarkerTop - offset,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const id = getOrCreateUserId();
    setUserId(id);

    const handleScroll = () => {
      // Проверяем маркеры в порядке, соответствующем направлению прокрутки
      const markers =
        window.scrollY > lastScrollY
          ? markersRef.current // Сверху вниз
          : [...markersRef.current].reverse(); // Снизу вверх

      // Находим первый видимый маркер
      const visibleMarker = markers.find((marker) => {
        if (!marker) return false;

        const rect = marker.getBoundingClientRect();
        const visibleThreshold = window.innerHeight * 0.1; // 30% высоты экрана

        // Элемент считается видимым, если:
        // - Его верхняя граница выше нижней границы экрана (не скрыт внизу)
        // - Его нижняя граница ниже верхней границы экрана (не скрыт вверху)
        // - При этом хотя бы 30% высоты элемента видно
        return (
          rect.top <= window.innerHeight - visibleThreshold &&
          rect.bottom >= visibleThreshold
        );
      });

      if (visibleMarker) {
        // Безопасное извлечение ID из dataset
        const markerId = visibleMarker.dataset.id;
        const idNumber = markerId
          ? parseInt(markerId.replace('item_', ''), 10)
          : 0;

        setCurrentPosition(idNumber);
        setLastScrollY(window.scrollY); // Сохраняем позицию скролла
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const handlerChange = () => {
    let cnt = WINDOW_V;
    if (window.innerWidth > DESCTOP_CHANGE) {
      cnt = WINDOW_H;
    }
    setWindowState(cnt);
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    handlerChange();
    checkDevice();
    setConstHeight(window.innerHeight);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handlerChange, false);
    return () => {
      window.removeEventListener('resize', handlerChange, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack
      style={{
        WebkitTextSizeAdjust: '100%',
      }}
    >
      <Stack
        width="100%"
        direction="column"
        sx={{
          top: 0,
          left: 0,
          position: 'absolute',
          overflow: 'hidden',
        }}
      >
        <MyAlert
          message={alertProps.message}
          severity={alertProps.severity}
          onClose={() => setAlertProps({ ...alertProps, message: '' })}
        />
        {windowState === WINDOW_V && (
          <Stack width="100%" alignItems="center" justifyContent="center">
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              sx={{
                zIndex: 100,
                borderRadius: '25px',
                backdropFilter: 'blur(6px)',
                WebkitBackdropFilter: 'blur(6px)',
                background: '#FFFFFF99',
                position: 'fixed',
                top: '20px',
              }}
            >
              <Stack
                width="60px"
                height="60px"
                alignItems="center"
                justifyContent="center"
                sx={{
                  background: currentPosition === 1 ? '#000000' : undefined,
                  borderRadius: '23px',
                }}
                onClick={() => scrollToMarker(1)}
              >
                {currentPosition !== 1 && (
                  <ProfileSvg
                    fill={currentPosition === 1 ? 'white' : 'black'}
                  />
                )}
                {currentPosition === 1 && (
                  <Icon1 fill={currentPosition === 1 ? 'white' : 'black'} />
                )}
              </Stack>
              <Stack
                width="60px"
                height="60px"
                alignItems="center"
                justifyContent="center"
                sx={{
                  background: currentPosition === 2 ? '#000000' : undefined,
                  borderRadius: '23px',
                }}
                onClick={() => scrollToMarker(2)}
              >
                {currentPosition !== 2 && (
                  <IdeaSvg stroke={currentPosition === 2 ? 'white' : 'black'} />
                )}
                {currentPosition === 2 && (
                  <Icon2 fill={currentPosition === 2 ? 'white' : 'black'} />
                )}
              </Stack>
              <Stack
                width="60px"
                height="60px"
                alignItems="center"
                justifyContent="center"
                sx={{
                  background: currentPosition === 3 ? '#000000' : undefined,
                  borderRadius: '23px',
                }}
                onClick={() => scrollToMarker(3)}
              >
                {currentPosition !== 3 && (
                  <StarSvg stroke={currentPosition === 3 ? 'white' : 'black'} />
                )}
                {currentPosition === 3 && (
                  <Icon3 fill={currentPosition === 3 ? 'white' : 'black'} />
                )}
              </Stack>
              {false && (
                <Stack
                  width="60px"
                  height="60px"
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    background: currentPosition === 4 ? '#000000' : undefined,
                    borderRadius: '23px',
                  }}
                  onClick={() => scrollToMarker(4)}
                >
                  {currentPosition !== 4 && (
                    <PremiumSvg
                      stroke={currentPosition === 4 ? 'white' : 'black'}
                    />
                  )}
                  {currentPosition === 4 && (
                    <Icon4 fill={currentPosition === 4 ? 'white' : 'white'} />
                  )}
                </Stack>
              )}
            </Stack>
          </Stack>
        )}

        {currentPosition < 3 && windowState === WINDOW_V && (
          <Stack width="100%" alignItems="center" justifyContent="center">
            <Stack
              width="100%"
              direction="row"
              padding="14px"
              alignItems="center"
              justifyContent="left"
              paddingLeft="100px"
              sx={{
                zIndex: 100,
                position: 'fixed',
                paddingBottom: '20px',
                bottom: '0px',
                background:
                  currentPosition < 3
                    ? 'linear-gradient(180deg, rgba(229, 234, 237, 0) 0%, #E5EAED 100%)'
                    : 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)',
              }}
              spacing={1}
            >
              {currentPosition !== 0 && (
                <Stack onClick={() => HandleAutoShopView(autoDevice)}>
                  <img alt="" width="60px" height="60px" src={AppInstall} />
                </Stack>
              )}
              {false && (
                <MyButton
                  text={
                    <Typography
                      fontWeight={400}
                      fontFamily="Roboto"
                      lineHeight="100%"
                      fontSize="14px"
                      letterSpacing="0.3px"
                      textAlign="center"
                      color="#FFFFFF"
                      component="text"
                    >
                      Оформить
                    </Typography>
                  }
                  background="#000000"
                  color="#3478F6"
                  borderRadius="25px"
                  width={currentPosition === 0 ? '321px' : '251px'}
                  height="60px"
                  onClick={() => scrollToMarker(4)}
                />
              )}
            </Stack>
          </Stack>
        )}

        {windowState === WINDOW_V && (
          <Stack
            width="100%"
            height={constHeight}
            alignItems="center"
            justifyContent="center"
            sx={{
              background: '#E5EAED',
              backgroundImage: `url(${Skelet})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right top',
              backgroundSize: `${getSizePictureFona()}`,
            }}
          >
            <Stack
              key="item_0"
              ref={addToRefs}
              data-id="item_0"
              direction="row"
              width="100%"
              justifyContent="left"
            >
              <Stack paddingLeft="20px" width="170px" spacing={3}>
                <img alt="" width="100px" height="100px" src={Logo} />
                <Stack paddingLeft="20px" spacing={2}>
                  <img alt="" width="123px" height="26px" src={NameSkeleton} />
                  <Stack spacing={0}>
                    <Typography
                      fontWeight={700}
                      fontFamily="Roboto"
                      lineHeight="20px"
                      fontSize="12px"
                      letterSpacing="0.3px"
                      textAlign="left"
                      color="#000000"
                      component="text"
                    >
                      Образовательное
                    </Typography>
                    <Typography
                      fontWeight={400}
                      fontFamily="Roboto"
                      lineHeight="20px"
                      fontSize="12px"
                      letterSpacing="0.3px"
                      textAlign="left"
                      color="#000000"
                      component="text"
                    >
                      мобильное приложение для студентов медицинских ВУЗов
                    </Typography>
                  </Stack>
                </Stack>
                <MyButton
                  text={
                    <Typography
                      fontWeight={400}
                      fontFamily="Roboto"
                      lineHeight="100%"
                      fontSize="14px"
                      letterSpacing="0.3px"
                      textAlign="center"
                      color="#FFFFFF"
                      component="text"
                    >
                      Установить
                    </Typography>
                  }
                  background="#3478F6"
                  color="#3478F6"
                  borderRadius="25px"
                  width="130px"
                  height="60px"
                  onClick={() => HandleAutoShopView(autoDevice)}
                />
              </Stack>
            </Stack>
          </Stack>
        )}
        {windowState === WINDOW_H && (
          <Stack
            key="item_0"
            ref={addToRefs}
            data-id="item_0"
            width="100%"
            height={window.innerHeight}
            alignItems="center"
            justifyContent="center"
            sx={{
              background: '#E5EAED',
              backgroundImage: `url(${DesctopImage})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right top',
              backgroundSize: `${getSizePictureFona()}`,
            }}
          >
            <Stack direction="row" width="100%" justifyContent="left">
              <Stack
                paddingLeft="160px"
                direction="row"
                width="170px"
                spacing={3}
              >
                <Stack spacing={3}>
                  <img alt="" width="100px" height="100px" src={Logo} />

                  <Stack
                    width="100%"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Stack
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                      sx={{
                        zIndex: 100,
                        borderRadius: '25px',
                        position: 'fixed',
                        paddingTop: '250px',
                      }}
                    >
                      <Stack
                        width="60px"
                        height="60px"
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                          background:
                            currentPosition === 1 ? '#000000' : undefined,
                          borderRadius: '23px',
                        }}
                        onClick={() => scrollToMarker(1)}
                      >
                        {currentPosition !== 1 && (
                          <ProfileSvg
                            fill={currentPosition === 1 ? 'white' : 'black'}
                          />
                        )}
                        {currentPosition === 1 && (
                          <Icon1
                            fill={currentPosition === 1 ? 'white' : 'black'}
                          />
                        )}
                      </Stack>
                      <Stack
                        width="60px"
                        height="60px"
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                          background:
                            currentPosition === 2 ? '#000000' : undefined,
                          borderRadius: '23px',
                        }}
                        onClick={() => scrollToMarker(2)}
                      >
                        {currentPosition !== 2 && (
                          <IdeaSvg
                            stroke={currentPosition === 2 ? 'white' : 'black'}
                          />
                        )}
                        {currentPosition === 2 && (
                          <Icon2
                            fill={currentPosition === 2 ? 'white' : 'black'}
                          />
                        )}
                      </Stack>
                      <Stack
                        width="60px"
                        height="60px"
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                          background:
                            currentPosition === 3 ? '#000000' : undefined,
                          borderRadius: '23px',
                        }}
                        onClick={() => scrollToMarker(3)}
                      >
                        {currentPosition !== 3 && (
                          <StarSvg
                            stroke={currentPosition === 3 ? 'white' : 'black'}
                          />
                        )}
                        {currentPosition === 3 && (
                          <Icon3
                            fill={currentPosition === 3 ? 'white' : 'black'}
                          />
                        )}
                      </Stack>
                      {false && (
                        <Stack
                          width="60px"
                          height="60px"
                          alignItems="center"
                          justifyContent="center"
                          sx={{
                            background:
                              currentPosition === 4 ? '#000000' : undefined,
                            borderRadius: '23px',
                          }}
                          onClick={() => scrollToMarker(4)}
                        >
                          {currentPosition !== 4 && (
                            <PremiumSvg
                              stroke={currentPosition === 4 ? 'white' : 'black'}
                            />
                          )}
                          {currentPosition === 4 && (
                            <Icon4
                              fill={currentPosition === 4 ? 'white' : 'white'}
                            />
                          )}
                        </Stack>
                      )}
                    </Stack>
                  </Stack>
                </Stack>
                <Stack paddingLeft="20px" spacing={2}>
                  <Stack paddingTop="35px">
                    <img
                      alt=""
                      width="185px"
                      height="39px"
                      src={NameSkeleton}
                    />
                    <Typography
                      paddingLeft="5px"
                      fontWeight={400}
                      fontFamily="Roboto"
                      lineHeight="20px"
                      fontSize="14px"
                      letterSpacing="0.3px"
                      textAlign="left"
                      color="#00C7D3"
                      component="text"
                    >
                      Приложение
                    </Typography>
                  </Stack>

                  <Stack spacing={0} paddingBottom="30px" paddingLeft="5px">
                    <Typography
                      fontWeight={400}
                      fontFamily="Roboto"
                      lineHeight="20px"
                      fontSize="12px"
                      letterSpacing="0.3px"
                      textAlign="left"
                      color="#000000"
                      component="text"
                    >
                      <span
                        style={{
                          fontWeight: '700',
                          fontFamily: 'Roboto',
                          lineHeight: '20px',
                          fontSize: '12px',
                          letterSpacing: '0.3px',
                          textAlign: 'left',
                          color: '#000000',
                        }}
                      >
                        Образовательное
                      </span>{' '}
                      мобильное приложение для студентов медицинских ВУЗов
                    </Typography>
                  </Stack>
                  <Stack
                    direction={
                      windowWidth > DESCTOP_TWO_BUTTON_CHANGE ? 'row' : 'column'
                    }
                    spacing={1}
                  >
                    {autoDevice !== 4 && (
                      <MyButton
                        text={
                          <Typography
                            fontWeight={400}
                            fontFamily="Roboto"
                            lineHeight="100%"
                            fontSize="14px"
                            letterSpacing="0.3px"
                            textAlign="center"
                            color="#FFFFFF"
                            component="text"
                          >
                            Установить
                          </Typography>
                        }
                        background="#3478F6"
                        color="#3478F6"
                        borderRadius="20px"
                        width="120px"
                        height="50px"
                        onClick={() => HandleAutoShopView(autoDevice)}
                      />
                    )}
                    {windowWidth > DESCTOP_TWO_BUTTON_CHANGE &&
                      autoDevice === 4 && (
                        <Stack direction="row" spacing={1}>
                          <Stack onClick={() => HandleAutoShopView(0)}>
                            <img
                              alt=""
                              width="50px"
                              height="50px"
                              src={ApplShop}
                            />
                          </Stack>
                          <Stack onClick={() => HandleAutoShopView(1)}>
                            <img
                              alt=""
                              width="50px"
                              height="50px"
                              src={AndroidShop}
                            />
                          </Stack>
                          <Stack onClick={() => HandleAutoShopView(2)}>
                            <img
                              alt=""
                              width="50px"
                              height="50px"
                              src={HuaweiShop}
                            />
                          </Stack>
                        </Stack>
                      )}
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        )}

        <Stack width="100%" key="item_1" ref={addToRefs} data-id="item_1">
          <Stack width="100%">
            <LendingDivItemText
              title="Предметы для изучения"
              text="Приложение помогает в изучении ряда сложнейших предметов на пути студента"
              widthTitle={windowState === WINDOW_V ? '145px' : '258px'}
              widthText={windowState === WINDOW_V ? '176px' : '251px'}
              height="600px"
              windowState={windowState}
            />
          </Stack>
          <Stack spacing={0.5}>
            <LendingDivtemTextWithImage
              image1={Anat}
              image2={windowState === WINDOW_V ? SkeletonLend1 : SkeletonLend5}
              title="Анатомия"
              text="Анатомия в 3D-формате знаменует современный подход к изучению строения человеческого организма. Использование интерактивных трёхмерных моделей позволяет детально рассмотреть органы и системы"
              widthTitle="95px"
              widthText={windowState === WINDOW_V ? '190px' : '335px'}
              imageSize={
                windowState === WINDOW_V ? '363px 290px' : '350px 259px'
              }
              windowState={windowState}
            />
            <LendingDivtemTextWithImage
              image1={Hist}
              image2={windowState === WINDOW_V ? SkeletonLend2 : SkeletonLend6}
              title="Гистология"
              text="Курс знакомит студентов с микроскопическим строением клеток, тканей и органов человека. Изучение дисциплины формирует представление о взаимосвязи структуры и функции на клеточном и тканевом уровнях"
              widthTitle="95px"
              widthText={windowState === WINDOW_V ? '190px' : '335px'}
              imageSize={
                windowState === WINDOW_V ? '225px 290px' : '234px 259px'
              }
              windowState={windowState}
            />
            <LendingDivtemTextWithImage
              image1={Bioc}
              image2={windowState === WINDOW_V ? SkeletonLend3 : SkeletonLend7}
              title="Биохимия"
              text="Курс формирует фундаментальные знания о молекулярных основах жизнедеятельности организма. В материалах рассматриваются основные классы химических соединений и их участие в биохимических процессах организма"
              widthTitle="95px"
              widthText={windowState === WINDOW_V ? '190px' : '335px'}
              imageSize={
                windowState === WINDOW_V ? '210px 290px' : '215px 230px'
              }
              windowState={windowState}
            />
            <LendingDivtemTextWithImage
              image1={Phys}
              image2={windowState === WINDOW_V ? SkeletonLend4 : SkeletonLend8}
              title="Физиология"
              text="Курс направлен на изучение функций клеток, тканей, органов и систем организма, а также механизмов их регуляции и взаимодействия"
              widthTitle="95px"
              widthText={windowState === WINDOW_V ? '190px' : '335px'}
              imageSize={
                windowState === WINDOW_V ? '245px 290px' : '346px 259px'
              }
              windowState={windowState}
            />
          </Stack>
        </Stack>

        <Stack
          paddingLeft={windowState === WINDOW_V ? '72px' : '300px'}
          paddingTop="100px"
        >
          <Divider
            sx={{
              width: '32px',
              border: '2px solid rgba(0, 0, 0, 1)',
              borderRadius: '3px',
            }}
            orientation="horizontal"
            flexItem
          />
        </Stack>
        <Stack width="100%" key="item_2" ref={addToRefs} data-id="item_2">
          <LendingDivItemText
            title="Методы обучения"
            text="Разработан ряд эффективных инструментов для обучения, которые уже зарекомендовали себя на практике"
            widthTitle={windowState === WINDOW_V ? '145px' : '366px'}
            widthText={windowState === WINDOW_V ? '176px' : '298px'}
            height="600px"
            windowState={windowState}
          />

          <LendingDivtemTextWithImage2
            image1={Fullbody}
            image2={Image1}
            image5={Image5}
            isChange
            title="3D-модель всего тела"
            text="Возможность изучать анатомию в 3D-модели всего тела, что позволяет понять и проследить их пространственные взаимоотношения"
            widthTitle="121px"
            widthText="190px"
            windowState={windowState}
          />
          <LendingDivtemTextWithImage2
            image1={Blog}
            image2={Image2}
            image5={Image6}
            isChange={false}
            title="Интерактивные конспекты с анимацией и 3D"
            text="Изучайте анатомию в виде интерактивных конспектов в формате 3D, и другие предметы в формате анимаций"
            widthTitle="162px"
            widthText="190px"
            windowState={windowState}
          />
          <LendingDivtemTextWithImage2
            image1={Listen}
            image2={Image3}
            image5={Image7}
            isChange={false}
            title="Озвучка конспектов и терминов"
            text="Учите произношение сложных терминов также легко как прослушивание подкаста или аудиокниги"
            widthTitle="191px"
            widthText="190px"
            windowState={windowState}
          />
          <LendingDivtemTextWithImage2
            image1={Latin}
            image2={Image8}
            image5={Image4}
            isChange
            title="Удобное изучение латыни"
            text="Проверяйте свое знание латинских терминов с нашими латинскими карточками"
            widthTitle="191px"
            widthText="190px"
            windowState={windowState}
          />
        </Stack>
        <Stack paddingTop="50px"> </Stack>
        <Stack
          sx={{
            background: `#1D2228`,
          }}
          paddingLeft={windowState === WINDOW_H ? '300px' : undefined}
          key="item_3"
          ref={addToRefs}
          data-id="item_3"
          paddingTop="50px"
        >
          <Stack paddingTop="50px" spacing={1}>
            <Typography
              width={windowState === WINDOW_V ? '217px' : '500px'}
              paddingLeft="50px"
              fontWeight={700}
              fontFamily="Comfortaa"
              lineHeight="28px"
              fontSize="24px"
              letterSpacing="0.3px"
              textAlign="left"
              color="#FFFFFF"
              component="text"
            >
              Отзывы пользователей
            </Typography>
            <Stack
              direction="row"
              padding="30px"
              sx={{
                overflowX: 'auto',
              }}
              spacing={1}
            >
              <LendingDivItemTextOtziv
                zagolovok="JonSnowl"
                device={0}
                windowState={windowState}
                title="Волшебная палочка"
                rating={5}
                text="Самое шикарное и удобное приложения для студента медика ❤️ Очень выручает, пользуюсь уже больше года, ни разу не подводило по объёму и актуальности информации. Плюсом все красиво оформлено, глаз радуется!"
              />
              <LendingDivItemTextOtziv
                zagolovok="gulizafoniiia"
                device={0}
                windowState={windowState}
                title="Лучшее приложение для понимания анатомии!!"
                rating={5}
                text="Пишу на эмоциях, так как материалы очень помогли за короткий срок повторить все темы без воды до экзамена! Программы в вузах могут отличаться, но база в этом приложении прекрасная 💔 Разработчикам и автору спасибо!)"
              />
              <LendingDivItemTextOtziv
                zagolovok="y0oyyy"
                device={0}
                windowState={windowState}
                title="рекомендую!"
                rating={5}
                text="сдавала анатомию, на картинках вообще ничего не понимала и не запоминала, но это приложение просто чудо, все наглядно можно рассмотреть, все системы органов проработаны, что очень помогает"
              />
              <LendingDivItemTextOtziv
                zagolovok="Powerrain"
                device={0}
                windowState={windowState}
                title="Отличное приложение"
                rating={5}
                text="Спасибо огромное за ваше приложение, пользовался им для подготовки к анатомии все полтора года курса анатомии, учился в основном по нему, очень полезное и нужное приложение, в котором вся информация структурированная и полная. Оно очень сильно помогло в изучении данного предмета !"
              />
            </Stack>
          </Stack>
        </Stack>
        <Stack
          paddingLeft={windowState === WINDOW_H ? '300px' : undefined}
          sx={{
            background: `#1D2228`,
          }}
        >
          <Stack
            paddingLeft="20px"
            paddingTop={windowState === WINDOW_V ? '100px' : '20px'}
            spacing={1}
          >
            <Typography
              width="217px"
              fontWeight={700}
              fontFamily="Comfortaa"
              lineHeight="28px"
              fontSize="20px"
              letterSpacing="0.3px"
              textAlign="left"
              color="#FFFFFF"
              component="text"
            >
              Авторы
            </Typography>
          </Stack>
          <Stack
            paddingLeft="20px"
            direction={windowWidth < DESCTOP_TWO_CHANGE ? 'column' : 'row'}
            paddingTop="20px"
            spacing={1}
          >
            <Stack spacing={0}>
              <Typography
                width="120px"
                fontWeight={400}
                fontFamily="Roboto"
                fontSize="12px"
                letterSpacing="0.3px"
                textAlign="left"
                color="#FFFFFF"
                component="text"
              >
                Артур Лисюков
              </Typography>
              <Typography
                width="120px"
                fontWeight={400}
                fontFamily="Robota"
                fontSize="12px"
                letterSpacing="0.3px"
                textAlign="left"
                color="#FFFFFF80"
                component="text"
              >
                Автор материалов
              </Typography>
            </Stack>
            <Stack spacing={0}>
              <Typography
                width="120px"
                fontWeight={400}
                fontFamily="Roboto"
                fontSize="12px"
                letterSpacing="0.3px"
                textAlign="left"
                color="#FFFFFF"
                component="text"
              >
                Матвей Малацион
              </Typography>
              <Typography
                width="120px"
                fontWeight={400}
                fontFamily="Robota"
                fontSize="12px"
                letterSpacing="0.3px"
                textAlign="left"
                color="#FFFFFF80"
                component="text"
              >
                iOS-разработчик
              </Typography>
            </Stack>
            <Stack spacing={0}>
              <Typography
                width="120px"
                fontWeight={400}
                fontFamily="Roboto"
                fontSize="12px"
                letterSpacing="0.3px"
                textAlign="left"
                color="#FFFFFF"
                component="text"
              >
                Марат Юсупов
              </Typography>
              <Typography
                width="120px"
                fontWeight={400}
                fontFamily="Robota"
                fontSize="12px"
                letterSpacing="0.3px"
                textAlign="left"
                color="#FFFFFF80"
                component="text"
              >
                Android разработчик
              </Typography>
            </Stack>
            <Stack spacing={0}>
              <Typography
                width="120px"
                fontWeight={400}
                fontFamily="Roboto"
                fontSize="12px"
                letterSpacing="0.3px"
                textAlign="left"
                color="#FFFFFF"
                component="text"
              >
                Рафис Юсупов
              </Typography>
              <Typography
                width="120px"
                fontWeight={400}
                fontFamily="Robota"
                fontSize="12px"
                letterSpacing="0.3px"
                textAlign="left"
                color="#FFFFFF80"
                component="text"
              >
                Back-end разработчик
              </Typography>
            </Stack>
            <Stack spacing={0}>
              <Typography
                width="150px"
                fontWeight={400}
                fontFamily="Roboto"
                fontSize="12px"
                letterSpacing="0.3px"
                textAlign="left"
                color="#FFFFFF"
                component="text"
              >
                Булат Гайнуллин
              </Typography>
              <Typography
                width="150px"
                fontWeight={400}
                fontFamily="Robota"
                fontSize="12px"
                letterSpacing="0.3px"
                textAlign="left"
                color="#FFFFFF80"
                component="text"
              >
                Дизайнер, 3D-моделлер
              </Typography>
            </Stack>
          </Stack>
        </Stack>
        <Stack
          sx={{
            background: `#1D2228`,
          }}
          paddingTop="50px"
        >
          {false && (
            <Stack paddingBottom="160px" spacing={2}>
              <Stack key="item_4" ref={addToRefs} data-id="item_4">
                <PurchaseDiv
                  onChange={onChange}
                  isLending
                  height={constHeight > 560 ? '560px' : `${constHeight}px`}
                  shopId={userId}
                  constHeight={constHeight}
                />
              </Stack>
            </Stack>
          )}
        </Stack>
        <LendingDivtemTextFooter windowState={windowState} />
      </Stack>
    </Stack>
  );
};
